import constants from "../constants.js";

export const EnhancedPolicyRulesActionsPnrExtraActionEmailBooking = {
    displayName: "Email Booking",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.EmailBooking",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};
export const EnhancedPolicyRulesActionsPnrExtraActionEmailModification = {
    displayName: "Email Modification",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.EmailModification",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};
export const EnhancedPolicyRulesActionsPnrExtraActionEmailCancel = {
    displayName: "Email Cancel",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.EmailCancel",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};
export const EnhancedPolicyRulesActionsPnrExtraActionEmaiApproval = {
    displayName: "Email Approval",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.EmaiApproval",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};
export const EnhancedPolicyRulesActionsPnrExtraActionEmailError = {
    displayName: "Email Error",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.EmailError",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrExtraActionProfileMoveProfileId = {
  displayName: "ProfileId",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.ProfileMoves.$EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem.ProfileId",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  validationRegex: "^\\d+$|undefined|null|^$",
  validationMessage: "Please enter only numerical digits here",
}
export const EnhancedPolicyRulesActionsPnrExtraActionProfileMoveProfileTypeCode = {
  displayName: "ProfileTypeCode",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.ProfileMoves.$EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem.ProfileTypeCode",
  optionsAt: "ProfileTypes",
  displayAs: constants.DISPLAY_AS.SELECT,
}

export const EnhancedPolicyRulesActionsPnrExtraActionProfileMovePcc = {
  displayName: "Pcc",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.ProfileMoves.$EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem.Pcc",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  validationRegex: "^[a-zA-Z0-9]{4,4}$|undefined|null|^$",
  validationMessage: "Please enter only 4 alpha numerical characters",
}

export const EnhancedPolicyRulesActionsPnrExtraActionProfileMovePnrBuilder = {
  displayName: "PnrBuilder",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.ProfileMoves.$EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem.PnrBuilder",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
}

export const EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem = {
    displayName: "Item",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.ProfileMoves.$EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem",
    displayAs: constants.DISPLAY_AS.RESOURCE,
    children: [
       EnhancedPolicyRulesActionsPnrExtraActionProfileMoveProfileId,
       EnhancedPolicyRulesActionsPnrExtraActionProfileMoveProfileTypeCode,
       EnhancedPolicyRulesActionsPnrExtraActionProfileMovePcc,
       EnhancedPolicyRulesActionsPnrExtraActionProfileMovePnrBuilder
    ],
    endpoint: "EnhancedPolicyRules",
    removeParamId: "EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem",
    canDelete: true,
  };

export const EnhancedPolicyRulesActionsPnrExtraActionProfileMovesGrid = {
    displayName: "Profile Moves",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.ProfileMoves",
    displayAs: constants.DISPLAY_AS.GRID,
    canCopyItem: true,
    canAddNew: true,
    gridItem: EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem,
    gridCols: [{ name: "ProfileId", key: "ProfileId" },
                { name: "ProfileTypeCode", key: "ProfileTypeCode" },
                { name: "Pcc", key: "Pcc" },
                { name: "PnrBuilder", key: "PnrBuilder" }
            ],
};

export const EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsQueueActionType = {
  displayName: "Queue Action",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.QueuePlacements.$EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem.QueueActionType",
  optionsAt: "QueueActionTypes",
  displayAs: constants.DISPLAY_AS.SELECT,
}

export const EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsNumber = {
  displayName: "Number",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.QueuePlacements.$EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem.Number",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  validationRegex: "^[0-9]{1,3}$|undefined|null|^$",
  validationMessage: "Please enter only valid queue numbers"
}
export const EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsPcc = {
  displayName: "Pcc",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.QueuePlacements.$EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem.Pcc",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  validationRegex: "^[a-zA-Z0-9]{4,4}$|undefined|null|^$",
  validationMessage: "Please enter only 4 Alpha Numeric Characters",
  label: "Optional, leave blank to use debtor configured Pcc."
}
export const EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsPrefatoryInstructionCode = {
  displayName: "Prefactory Code",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.QueuePlacements.$EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem.PrefatoryInstructionCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  validationRegex: "^[0-9]{1,3}$|undefined|null|^$",
  validationMessage: "Please enter only valid prefactory codes",
  label: "Optional, leave blank to use prefactory code used along with queue action selected."
}
export const EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem = {
    displayName: "Item",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.QueuePlacements.$EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem",
    displayAs: constants.DISPLAY_AS.RESOURCE,
    children: [
       EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsQueueActionType,
       EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsNumber,
       EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsPcc,
       EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsPrefatoryInstructionCode
    ],
    endpoint: "EnhancedPolicyRules",
    removeParamId: "EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem",
    canDelete: true,
  };

export const EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsGrid = {
    displayName: "Queue Placements",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.QueuePlacements",
    displayAs: constants.DISPLAY_AS.GRID,
    canCopyItem: true,
    canAddNew: true,
    gridItem: EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem,
    gridCols: [{ name: "QueueActionType", key: "QueueActionType" },
                { name: "Number", key: "Number" },
                { name: "Pcc", key: "Pcc" },
                { name: "PrefatoryInstructionCode", key: "PrefatoryInstructionCode" }
            ],
};






// WEBPACK FOOTER //
// ./src/config/fields/enhancedPolicyRulesPnrExtraAction.js